/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatCal = require('../types/NatCal')
const CValDyn = require('./CValDyn')
const CCalculAncetre = require('./CCalculAncetre')
module.exports = CMesureAire

/**
 * Classe représentant la mesure de l'aire d'un polygone.
 * @constructor
 * @extends CCalculAncetre
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {CPolygone} polygoneAssocie : Le polygone dont on mesure l'aire.
 * @param {String} nomCalcul : Le nom.
 * @returns {CMesureAire}
 */
function CMesureAire (listeProprietaire, impProto, estElementFinal,nomCalcul, polygoneAssocie) {
  if (arguments.length === 1) CValDyn.call(this, listeProprietaire);
  else {
    CCalculAncetre.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul);
    this.polygoneAssocie = polygoneAssocie;
    this.aire = 0;
  }
}
CMesureAire.prototype = new CCalculAncetre();
CMesureAire.prototype.constructor = CMesureAire;
CMesureAire.prototype.superClass = "CCalculAncetre";
CMesureAire.prototype.className = "CMesureAire";

CMesureAire.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.polygoneAssocie);
  var ind2 = listeSource.indexOf(this.impProto);
  return  new CMesureAire(listeCible, listeCible.get(ind2, "CImplementationProto"),
    this.estElementFinal, this.nomCalcul, listeCible.get(ind1, "CPolygone"));
};
CMesureAire.prototype.setClone = function(ptel) {
  this.aire = ptel.aire;
};
CMesureAire.prototype.ajouteAntecedents = function(liste) {
  liste.add(this.polygoneAssocie);
};
CMesureAire.prototype.nomIndispensable = function(el) {
  for (var i = 0; i < this.polygoneAssocie.collectionPoints.length; i++) {
    var nd = this.polygoneAssocie.collectionPoints.get(i);
    if (nd.pointeurSurPoint === el) return true;
  }
  return false;
};
CMesureAire.prototype.getNatureCalcul = function() {
  return NatCal.NMesureAirePolygone;
};
CMesureAire.prototype.depDe = function(p) {
  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
  return this.memDep(CCalculAncetre.prototype.depDe.call(this, p) || this.polygoneAssocie.depDe(p)
  || this.listeProprietaire.pointeurLongueurUnite.depDe(p));
};
CMesureAire.prototype.dependDePourBoucle = function(p) {
  return (p === this) || this.polygoneAssocie.dependDePourBoucle(p)
  || this.listeProprietaire.pointeurLongueurUnite.dependDePourBoucle(p);
};
CMesureAire.prototype.rendValeur = function() {
  return this.aire;
};
CMesureAire.prototype.positionne = function(infoRandom, dimfen) {
  var pLongUnite = this.listeProprietaire.pointeurLongueurUnite;
  this.existe = this.polygoneAssocie.existe && pLongUnite.existe;
  if (!this.existe) return;
  var longueurUnite = pLongUnite.rendLongueur();
  // Si la longueur unité est nulle, pLongUnite n'existe pas
  var aire = 0;
  var array = this.polygoneAssocie.colPoints;
  for (var i = 0; i < array.length - 1; i++ ) {
    var ptp1 = array[i].pointeurSurPoint;
    var ptp2 = array[i+1].pointeurSurPoint;
    aire += (ptp1.x*ptp2.y - ptp1.y*ptp2.x)/2;
  }
  this.aire = Math.abs(aire)/(longueurUnite*longueurUnite);
};
CMesureAire.prototype.confonduAvec = function(p) {
  if (p.className === this.className) {
    return this.polygoneAssocie === p.polygoneAssocie;
  }
  else return false;
};
CMesureAire.prototype.read = function(inps, list){
  CCalculAncetre.prototype.read.call(this, inps, list);
  var ind1 = inps.readInt();
  this.polygoneAssocie = list.get(ind1,"CPolygone");
};
CMesureAire.prototype.write = function(oups, list){
  CCalculAncetre.prototype.write.call(this, oups, list);
  var ind1 = list.indexOf(this.polygoneAssocie);
  oups.writeInt(ind1);
};
